var map = {
	"./CFD.png": "YIlj",
	"./GL.png": "OZeN",
	"./GL1.png": "vVZS",
	"./LJCY.gif": "t5gi",
	"./S.gif": "hiYj",
	"./S.png": "ykkR",
	"./VIP1.png": "oS5r",
	"./WXSM.png": "N6+U",
	"./YDZF.png": "hxQ1",
	"./activity_background.png": "mb6v",
	"./activity_background16.png": "HQJ8",
	"./activity_list.png": "0Rae",
	"./add-btn.png": "Bzzz",
	"./back.png": "DtD7",
	"./back1.jpg": "eJ1l",
	"./background_new.png": "ZUZz",
	"./banner.png": "P07D",
	"./banner1.png": "CMrX",
	"./banner_back.png": "wFA+",
	"./baopinquan.jpg": "4gWo",
	"./bck.jpg": "lv+l",
	"./biaoqian.png": "Fb4F",
	"./biaozhu.png": "hlvV",
	"./blast.png": "7dRe",
	"./blh.png": "09XA",
	"./book.png": "vzgd",
	"./box.png": "omNA",
	"./box1.png": "Tb/C",
	"./box_i.png": "mekx",
	"./box_img.png": "3HiE",
	"./center_nav.png": "2kMF",
	"./cfzx.png": "OczA",
	"./changxianquan.jpg": "KLR9",
	"./chongzhiquan.jpg": "Coq6",
	"./chuhuo.png": "1rI+",
	"./chuhuofail.png": "rOiJ",
	"./chuhuono.png": "1qMT",
	"./chuhuozhong.png": "lJJJ",
	"./chuxuka.png": "9X3I",
	"./close.png": "/TeD",
	"./close1.png": "pDIl",
	"./code.png": "9OQK",
	"./code1.jpg": "F5UT",
	"./code1.png": "D5eY",
	"./code2.jpg": "auqI",
	"./code2.png": "kpwS",
	"./code3.jpg": "iljD",
	"./code3.png": "Tetu",
	"./code4.png": "yLdZ",
	"./code_new.png": "BZvD",
	"./commodity_back.png": "wvdR",
	"./commodity_back_new.png": "oA+P",
	"./commodity_but.png": "Qu2R",
	"./commodity_on.png": "XDjL",
	"./commodity_phone_but.png": "Yrb1",
	"./commodity_phone_size.png": "g0ff",
	"./commodity_size.png": "HT9J",
	"./commodity_size2.png": "oOak",
	"./commodity_state.png": "O/PU",
	"./content.png": "rfwo",
	"./cs.png": "cbHU",
	"./czwh.png": "Tuyb",
	"./daikuan.png": "cQTr",
	"./dd.png": "F67Y",
	"./defaultLogo.jpg": "hbBZ",
	"./defaultLogo_heat.jpg": "fw2p",
	"./del-btn.png": "jy4F",
	"./dians.png": "87s6",
	"./digitalCurrency.png": "dBcl",
	"./dongtaifudai.gif": "kU4X",
	"./dui.png": "zU8R",
	"./duigou.png": "iW2f",
	"./equipment_new.png": "Sgyn",
	"./example0.jpg": "PK8P",
	"./example1.jpg": "1iGu",
	"./example_fbrx.jpg": "9//x",
	"./example_fljn.jpg": "ebVH",
	"./example_hzsj.jpg": "nAra",
	"./example_yyzz.jpg": "wdsn",
	"./fd.png": "Ahaf",
	"./fljn.png": "Yue9",
	"./foot_img.png": "y4Je",
	"./frame_new.png": "lUE6",
	"./fudai.png": "C104",
	"./fudai_1.png": "/bBt",
	"./fuli.png": "Ixsv",
	"./gongan.png": "cW4A",
	"./guanbi.png": "fwEV",
	"./guanlian.png": "OitG",
	"./home1.jpg": "z6eN",
	"./home2.jpg": "oIWM",
	"./home3.jpg": "lchM",
	"./home_code.jpg": "dVfb",
	"./hongbao.png": "gQwn",
	"./huipin.png": "k+Ep",
	"./huodong_bg.png": "34m0",
	"./hzbm.png": "IDoS",
	"./hzqt.png": "IdT5",
	"./industry.png": "wfYq",
	"./jfdh.png": "nUOM",
	"./jiantou.png": "gEds",
	"./jiantou1.png": "s9JL",
	"./kfzx.png": "geV7",
	"./kong.png": "OrkP",
	"./label.png": "G/Dw",
	"./left.png": "/IG+",
	"./lijian.png": "QMrb",
	"./ljcy.png": "mj5O",
	"./lmj.png": "HRFP",
	"./loading-sm.gif": "dHd8",
	"./loading.gif": "F7NO",
	"./lock1.png": "h7tl",
	"./lock2.png": "FW1q",
	"./login-bg1.jpg": "HqcA",
	"./login_bg2.jpg": "bHns",
	"./login_bg3.jpg": "5Dgd",
	"./login_password.png": "OwLi",
	"./login_user.png": "P8EM",
	"./logo.png": "iQH9",
	"./ma.png": "uW4u",
	"./manghe.png": "g+4n",
	"./manjian.png": "WK+n",
	"./manjian_btn.png": "Erdf",
	"./manjianquan.jpg": "r2q5",
	"./mbgi_goods_img_path.png": "Qsn/",
	"./md.png": "O0A5",
	"./menuhzbm.png": "b3M2",
	"./menukfzx.png": "uttn",
	"./menuxlh.png": "O6sn",
	"./miaoshaquan.jpg": "/MyX",
	"./more.png": "MprZ",
	"./nuanxin.png": "Zd8y",
	"./null.png": "2u6q",
	"./payment_type1.png": "OSd7",
	"./payment_type2.png": "bn7r",
	"./payment_type3.png": "jIcl",
	"./paymentlogo.png": "GVdN",
	"./percentage_down.png": "T+Ho",
	"./percentage_up.png": "9JEY",
	"./prizeBag.png": "Cli4",
	"./qhhd.png": "WM6C",
	"./qian.png": "UEY8",
	"./qiang.png": "XUVH",
	"./quan.png": "onGz",
	"./qyqdh.png": "g7am",
	"./right.png": "SuS5",
	"./rmb.png": "UdBs",
	"./shareBtn.png": "FzOG",
	"./shifan.png": "kODl",
	"./shop_jt.png": "jmrn",
	"./shop_title.png": "9V/b",
	"./sign_1.png": "vS9i",
	"./sign_2.png": "2eQ3",
	"./sign_3.png": "rpyn",
	"./sign_4.png": "gtbL",
	"./sign_5.png": "TA2v",
	"./sign_edit.png": "mAnn",
	"./sjyh.png": "xReh",
	"./sound_jy.png": "nY1R",
	"./sound_ky.png": "XjlS",
	"./step1.png": "MMz/",
	"./step2.png": "FLts",
	"./step3.png": "yIMT",
	"./submit.png": "tUGb",
	"./szqb.png": "ZUJd",
	"./tiao.png": "OYu6",
	"./tu1.png": "/qig",
	"./tu10.png": "HQtg",
	"./tu11.png": "W03i",
	"./tu12.png": "YUQ8",
	"./tu13.png": "qUyV",
	"./tu14.png": "pptc",
	"./tu15.png": "++/W",
	"./tu16.png": "juOm",
	"./tu17.png": "XJI+",
	"./tu18.png": "tTit",
	"./tu19.png": "ynL9",
	"./tu2.png": "4JZ5",
	"./tu20.png": "DIZA",
	"./tu21.png": "1qhx",
	"./tu3.png": "Gq5v",
	"./tu4.png": "LVg9",
	"./tu5.png": "Jzya",
	"./tu6.png": "vFb3",
	"./tu7.png": "RMqT",
	"./tu71.png": "AknR",
	"./tu8.1.png": "hYL3",
	"./tu8.png": "ttJo",
	"./tu9.png": "WTxD",
	"./tx.png": "+RyT",
	"./upload-plus.png": "c0cV",
	"./vip.png": "eIVD",
	"./weixin.png": "AVav",
	"./wx.png": "ZDm/",
	"./wx_s.png": "9WIi",
	"./wxbg.jpg": "QRaa",
	"./wxbj2.jpg": "uHYl",
	"./wxts.png": "IT/d",
	"./wxts_bg.png": "driM",
	"./xiang.png": "Zju/",
	"./xiaochengxu.jpg": "3ZNt",
	"./xiaochengxu.png": "iief",
	"./xinke.png": "mWg2",
	"./xinyongka.png": "y9Lo",
	"./xinyuan.png": "LzJG",
	"./xkjx.png": "PNPY",
	"./xkzx.png": "6sQc",
	"./xlh.png": "KyWg",
	"./xuxian.png": "/BfN",
	"./yh.png": "HrTx",
	"./yingyin.png": "JC3E",
	"./yinhang.png": "4Dt9",
	"./ysf.png": "aJ6t",
	"./ysf_s.png": "41c2",
	"./zfb.png": "1oGI",
	"./zfb_s.png": "n3+t",
	"./zhp.png": "nFDM",
	"./zixun.png": "Mgd0",
	"./？.png": "8WTU",
	"./￥.png": "gKww"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 128